import { useMemo } from "react"
import { useGetBuildingsQuery } from "../../services/bClientApi"
import { BuildingEntryType } from "../../Types/buildingTypes"

export default function useBuildingRefs() {

    const {
        data,
    } = useGetBuildingsQuery({
        buildingsQuery: {},
        pagination: {
            page: 1,
            limit: 1000,
        }
    }, {
        refetchOnFocus: false,
        refetchOnMountOrArgChange: 5 * 60
    })

    const buildingRef = useMemo(() => {
        const buildingList = data?.docs || []
        const buildingRefData: { [key: string]: BuildingEntryType } = {}
        buildingList.forEach((building: BuildingEntryType) => {
            if (building._id) {
                buildingRefData[building._id] = building
            }
        })
        return buildingRefData
    }, [data])

    return buildingRef
}
